// src/components/PanelWrapper.tsx
import React from 'react';

export type HierarchyLevel = 'primary' | 'secondary' | 'tertiary';
export type PanelType = 'kpi' | 'list' | 'hero' | 'chart' | 'chat' | 'form';

interface PanelWrapperProps {
  children: React.ReactNode;
  hierarchy?: HierarchyLevel;
  type?: PanelType;
  title?: string;
  badge?: string;
  actions?: React.ReactNode;
  demo?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const PanelWrapper: React.FC<PanelWrapperProps> = ({
  children,
  hierarchy = 'secondary',
  type = 'list',
  title,
  badge,
  actions,
  demo = false,
  className = '',
  style,
  onClick,
}) => {
  const panelClasses = [
    'panel',
    `panel--${type}`,
    hierarchy !== 'secondary' && `panel--${hierarchy}`,
    demo && 'panel--demo',
    className,
  ].filter(Boolean).join(' ');

  const showHeader = title || badge || actions;

  return (
    <div className={panelClasses} style={style} onClick={onClick}>
      {showHeader && (
        <div className="panel__header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {title && <span className="panel__title">{title}</span>}
            {badge && <span className="panel__badge">{badge}</span>}
          </div>
          {actions && <div>{actions}</div>}
        </div>
      )}
      <div className="panel__content">{children}</div>
    </div>
  );
};

export default PanelWrapper;
